import React, { Component } from 'react';
import AppDataLoader from './new/server/AppDataLoader';
//import axios from 'axios';
import Bible from './bible/Bible';
import { CircularProgress } from '@material-ui/core';
//import Chapters from './models/Chapters';
import HebrewDefinitionLookup from './new/definitions/HebrewDefinitionLookup';
import LexiconFactory from './new/lexicons/LexiconFactory';
import LexiconStore from './new/lexicons/LexiconStore';
import MainView from './MainView';
//import { Map as ImmutableMap } from 'immutable';
import MorphologyLookup from './new/morphology/MorphologyLookup';
import PropTypes from 'prop-types';
import Server from "./new/server/Server";
import SourceStore from './new/sources/SourceStore';
import Themed from './Themed';
//import Verses from './models/Verses';
import VersionFactory from './new/versions/VersionFactory';
//import Versions from './models/Versions';
import VersionStore from './new/versions/VersionStore';
import './MainApp.css';

export default class MainApp extends Component {
    static childContextTypes = {
        bible: PropTypes.instanceOf(Bible),
        //chapters: PropTypes.instanceOf(ImmutableMap),
        //verses: PropTypes.instanceOf(Map),
        //versions: PropTypes.instanceOf(Map),
        //bookTree: PropTypes.array,
        //verses: PropTypes.array,
        //versionManager: PropTypes.instanceOf(VersionManager),
        //verseManager: PropTypes.instanceOf(VerseManager),
        //sources: PropTypes.instanceOf(SourceStore),
        versions: PropTypes.instanceOf(VersionStore),
        //definitions: PropTypes.instanceOf(HebrewDefinitionLookup),
        lexicons: PropTypes.instanceOf(LexiconStore)
    }

    constructor(props) {
        super(props);
        this.lexicons = new LexiconStore(LexiconFactory.getLexicons());
        this.state = {
            bible: null,
            //chapters: null,
            //verses: null,
            //versions: null,
            //bookTree: null,
            //verses: null,
            //versionManager: null,
            //verseManager: null,
            //sources: null,
            versions: null,
            //definitions: null,
            error: null
        };
    }

    cacheFont(fontName) {
        const element = document.createElement('span');
        element.setAttribute('style', `visibility: hidden; font-family: ${fontName}`);
        document.body.appendChild(element);
        // Need to wait for font to be loaded before removing element.
        setTimeout(() => document.body.removeChild(element), 3000);
    }

    componentDidMount() {
        // Stylesheet-based fonts are not loaded until they are needed. This
        // causes issues with verse list item heights as sometimes the font is not
        // loaded until after the item has been sized. To avoid this we load them here.
        this.cacheFont('Bwhebb');
        this.cacheFont('Bwgrkl');

        /*Chapters.getAll()
                .then(chapters => {
                    this.setState({ chapters: ImmutableMap().withMutations(map => {
                        chapters.forEach(chapter => map.set(chapter.index, chapter));
                    })});
                })
                .catch(error => this.setState(prevState => ({ error: prevState.error || error })));*/
        /*Verses.getAll()
                .then(verses => {
                    const map = new Map();
                    verses.forEach(verse => map.set(verse.index, verse));
                    this.setState({ verses: map });
                })
                .catch(error => this.setState(prevState => ({ error: prevState.error || error })));*/
        /*Versions.getAll()
                .then(versions => {
                    const map = new Map();
                    versions.forEach(version => map.set(version.index, version));
                    map.set(1000, {
                        name: 'Hebrew Interlinear',
                        code: 'WLCi',
                        index: 1000,
                        language: 'hebrew',
                        type: 'version',
                        stemsIndex: null
                    });
                    map.set(1001, {
                        name: 'Greek Interlinear',
                        code: 'WHOi',
                        index: 1001,
                        language: 'greek',
                        type: 'version',
                        stemsIndex: null
                    });
                    this.setState({ versions: map });
                })
                .catch(error => this.setState(prevState => ({ error: prevState.error || error })));*/
        /*Versions.getManager()
                .then(versionManager => {
                    //const versionManager = new VersionManager(versions);
                    //versionManager.addCustom('Hebrew Interlinear', 'WLCi', 'hebrew', 1000);
                    //versionManager.addCustom('Greek Interlinear', 'WHOi', 'greek', 1001);
                    this.setState({ versionManager });
                })
                .catch(error => this.setState(prevState => ({ error: prevState.error || error })));*/
        /*axios.get(Server.url('books/verses'))
                .then(response => {
                    const bookTree = response.data;
                    if (!Array.isArray(bookTree)) {
                        throw new Error('Array expected');
                    }
                    this.setState({ bookTree });
                })
                .catch(error => this.setState(prevState => ({ error: prevState.error || error })));*/
        Server.newRequest().get('verses')
                .then(response => {
                    if (!Array.isArray(response)) {
                        throw new Error('Array expected');
                    }
                    // "Decompress" verse data.
                    const verses = response.map(verse => {
                        return {
                            name: verse.n,
                            shortName: verse.sn,
                            index: verse.i,
                            bookIndex: verse.bi,
                            chapterIndex: verse.ci,
                            testament: verse.t
                        };
                    });
                    this.setState({
                        bible: Bible.fromVerses(verses),
                        //verses
                    });
                })
                .catch(error => this.setState(prevState => ({ error: prevState.error || error })));

        AppDataLoader.load()
            .then(data => {
                const sources = new SourceStore(data.sources);
                const definitions = new HebrewDefinitionLookup(data.hebrewDefinitions);
                const morphology = new MorphologyLookup(data.morphology);
                const versions = new VersionStore(VersionFactory.getVersions(sources, definitions, morphology));
                this.setState({
                    //definitions,
                    //sources,
                    versions
                });
            })
            .catch(error => this.setState(prevState => ({ error: prevState.error || error })));
    }

    getChildContext() {
        return {
            bible: this.state.bible,
            //chapters: this.state.chapters,
            //verses: this.state.verses,
            //versions: this.state.versions,
            //bookTree: this.state.bookTree,
            //verses: this.state.verses,
            //versionManager: this.state.versionManager,
            //verseManager: this.state.verseManager,
            //sources: this.state.sources,
            versions: this.state.versions,
            //definitions: this.state.definitions,
            lexicons: this.lexicons
        };
    }

    allLoaded() {
        const items = [
            this.state.bible,
            //this.state.chapters,
            //this.state.verses,
            //this.state.versions,
            //this.state.verses,
            //this.state.versionManager,
            //this.state.verseManager,
            //this.state.sources,
            this.state.versions,
            //this.state.definitions
        ];
        return items.every(item => item !== null);
        //return this.state.verses !== null && this.state.versions !== null &&
                ///*this.state.bookTree !== null &&*/ this.state.verses2;
    }

    render() {
        let content;
        if (this.state.error) {
            content = <div className="MainApp_Error">Error: {this.state.error.message}</div>;
        } else if (this.allLoaded()) {
            content = <MainView />;
        } else {
            content = <CircularProgress className="MainApp_Loading" color="secondary" />;
        }
        return <Themed>{content}</Themed>;
    }
}
